import { DateTime } from "luxon";

const formatDate = (date: string, format = "dd/MM/yyyy") => {
  return DateTime.fromISO(date).toFormat(format);
};
export default formatDate;
